import type {LDFlagSet} from 'launchdarkly-react-client-sdk';

export const FLAG_DEFAULTS: LDFlagSet = {
  DEFAULT_FLAG: true,
};
